import { PluginManifest } from '@/lib/platform/types/plugins';

export const manifest: PluginManifest = {
  id: 'cash-flow-visualization',
  name: 'Sankey Chart for Valuation Details',
  version: '1.0.0',
  minSystemVersion: '1.0.0',
  pluginApiVersion: '1.0',
  description: 'Advanced alluvial-style flow diagram showing valuation component breakdowns',
  author: 'Valiyou',
  homepage: 'https://valiyou.com/plugins/cash-flow-visualization',
};
